export default __webpack_public_path__ + "static/media/international-women-s-day-banner.c31821f9.svg";